import { createFileRoute } from "@tanstack/react-router";
import { PlanUsagePage } from "@/features/plans/plan-usage";

export const Route = createFileRoute("/_app/settings/plan")({
  head: () => ({ meta: [{ title: "Plan & billing · Settings · Malfak" }] }),
  component: PlanUsagePage,
});
